import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FmcToSdService } from 'src/app/Services/FmcToSd/fmc-to-sd.service';
import { DropDownService } from 'src/app/Services/DropDown/dropdownService';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-fmc-to-sd',
  templateUrl: './fmc-to-sd.component.html',
  styleUrls: ['./fmc-to-sd.component.css']
})
export class FmcToSdComponent implements OnInit {
  @ViewChild('file') file;
  public userId: string = localStorage.getItem('dsu_userId');
  public userName: string = localStorage.getItem('dsu_userName')
  public roleId: string = localStorage.getItem('dsu_roleId');
  public FlagDropDown: string;
  public loader: string = "none";
  public files: File[] = [];
  public fileName: string = '';

  fmcToSdobj: any = [];
  totalRecord: any;
  currentPage: any;
  lastPage: any;
  isDisabledPrevious = true;
  isDisabledNext = false;
  defaultView: boolean = true;
  recordsOnCurrentPage: any = 5;
  currentDate = new Date();
  startRecord: any = 0;


  constructor(private fmcToSd: FmcToSdService, private ddlServices: DropDownService, private toastr: ToastrService) {

  }


  ngOnInit() {
    this.loader = 'block';
    this.GetExcelData(0);

  }
  fileUpload(files: File[]) {
    this.loader = 'block';
    this.files = [];
    this.files = files;
    let fileNameParts: string[] = files[0].name.split('.');
    let fileType = files[0].name.split('.')[fileNameParts.length - 1];
    // let requirmentType = Array.prototype.map.call(this.requirmentType.selectedItems, function (item) { return item.text; }).join(",");
    if (fileType != 'xls' && fileType != 'xlsx') {
      // this.snackBar.openSnackBar('Please Select Valid File Type.','Close','red-snackbar');
      this.toastr.error("Please Select Valid File Type.");
      this.loader = 'none';
      return false;

    }

    this.loader = 'block';
    let fileValue = <File>this.files[0];
    this.fmcToSd.uploadDocument(fileValue, this.userId)
      .subscribe((resData: any) => {
        console.log(resData);
        if (resData.status) {
          this.toastr.success(resData.data);
          this.GetExcelData(0);
          // if (resData.data[0].result === "Success") {
          //   this.toastr.success(resData.data[0].errordescription);
          // }
          // else {
          //   this.toastr.error(resData.data[0].errordescription);
          // }
        }
        else {
          this.toastr.error(resData.data);
        }
        this.file.nativeElement.value = '';
        this.loader = 'none';
      }, error => {
        this.file.nativeElement.value = '';
        this.loader = 'none';
        this.toastr.error('Some Problem Occured, Please try again later.');
      });

  }
  DownloadExcel() {
    this.loader = 'block';
    this.userId = localStorage.getItem('dsu_userId');
    let today = new Date();
    let month;
    if((today.getMonth() + 1)<10)
    {
        month = '0' + (today.getMonth() + 1).toString().slice(-2);
    }
    else
    {
          month =  (today.getMonth() + 1).toString().slice(-2);
    }
    let formattedDate = today.getDate() + "_" + month + "_" + today.getFullYear();
    this.fmcToSd.DownloadExcel(this.userId)
      .subscribe(success => {
        if (success.ok = true) {
          var blob = new Blob([success.blob()], { type: 'application/vnc.openxmlformats-officedocument.spreadsheetxml.sheet' })
          saveAs(blob, this.userName + "_FmcToSd_" + formattedDate + ".xlsx");
        }
        this.loader = 'none';
      },
        err => {
          this.toastr.error('No data found');
          //alert("Some problem occurred while downloading file.");
          this.loader = 'none';
        });
  }
  GetExcelData(currentPage: any) {
    this.isDisabledPrevious = true;
    this.isDisabledNext = false;
    this.userId = localStorage.getItem('dsu_userId');
    let page = currentPage;
    this.loader = 'block';
    this.startRecord = 1;
    this.fmcToSd.ShowDataOnScreen(this.userId, page)
      .subscribe((resData: any) => {
        if (resData.status) {
          this.fmcToSdobj = resData.data;
          this.loader = 'none';
          this.defaultView = false;
          this.totalRecord = this.fmcToSdobj.pagination.totalRecord;
          this.currentPage = this.fmcToSdobj.pagination.currentPage;
          this.lastPage = this.fmcToSdobj.pagination.lastPage;
          this.recordsOnCurrentPage = this.currentPage * 5;
          if (this.currentPage > 1) {
            this.isDisabledPrevious = false;
            this.startRecord = (this.currentPage * 5) - 4;

          }
          if (this.currentPage == this.lastPage) {
            this.isDisabledNext = !this.isDisabledNext;
            this.recordsOnCurrentPage = this.totalRecord;
          }
          if (this.fmcToSdobj.fmcToSdData.length == 0) {
            this.startRecord = 0;
            this.recordsOnCurrentPage = 0;
          }
        }
      },
        err => {
          this.toastr.error('Some Problem Occured,Please try again later.');
          //alert("Some problem occurred while downloading file.");
          this.loader = 'none';
        });
  }
}




